import { render, staticRenderFns } from "./Expert2FitmentEdit.vue?vue&type=template&id=5fb33637&scoped=true&"
import script from "./Expert2FitmentEdit.vue?vue&type=script&lang=js&"
export * from "./Expert2FitmentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb33637",
  null
  
)

export default component.exports